export const serviceUsers = [
    {
        "nomInstitution": "Pharmacie",
        "adresseInstitution": "Golf",
        "email": "pharm@yopmail.com",
        "telephone": "+22378694512",
        "typeIntitution": "pharmacie",
        "gerant": "tout droits",
        "poste": "directeur",
        "Etat": "actif"
    },
    {
        "nomInstitution": "Clinique optique",
        "adresseInstitution": "Niamana",
        "email": "clin@yopmail.com",
        "telephone": "+22178965412",
        "typeIntitution": "clinique",
        "gerant": "Gestion des abonnées",
        "poste": "daf",
        "Etat": "actif"
    },

    {
        "nomInstitution": "clinique dentaire",
        "adresseInstitution": "Cité Unicef",
        "email": "dent@yopmail.com",
        "telephone": "+22178965412",
        "typeIntitution": "Clinique dentaire",
        "gerant": "Gestion des abonnées",
        "poste": "admin",
        "Etat": "actif"
    },

]